<template>
  <div class="login-wrap">
    <img src="../../assets/imgs/loginBg.png" alt="" class="bg" />
    <div style="display: flex; margin: 10% auto">
      <div class="loginImg">
        <img src="../../assets/imgs/loginImg.png" alt="" />
      </div>
      <div class="login">
        <div class="boxTitle">咖德保安运营管理系统</div>
        <div class="sub-title">
          <!-- <div
            :class="['title_text', type == 1 ? 'subSelect' : '']"
            @click="select(1)"
          >
            密码登录
          </div> -->
          <!-- <div class="solid"></div>
          <div
            :class="['title_text', type == 2 ? 'subSelect' : '']"
            @click="select(2)"
          >
            短信验证码登录
          </div> -->
        </div>
        <div v-if="type == 1">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            class="demo-ruleForm"
          >
            <el-form-item label="" prop="name"
              ><div class="item">
                <el-input
                  v-model="ruleForm.name"
                  placeholder="请输入账号"
                ></el-input></div
            ></el-form-item>
            <el-form-item label="" prop="pass"
              ><div class="item">
                <el-input
                  v-model="ruleForm.pass"
                  placeholder="请输入密码"
                  show-password
                ></el-input></div
            ></el-form-item>
            <el-form-item label="" prop="code">
              <div class="item">
                <el-input
                  v-model="ruleForm.code"
                  placeholder="请输入验证码"
                ></el-input>
                <div class="sendCode">
                  <img
                    @click="getImg"
                    :src="codeObj.imageBase"
                    alt=""
                    style="width: 100px; height: 40px; margin-left: 20px"
                  />
                </div></div
            ></el-form-item>
            <el-form-item>
              <div class="btn" @click="onSubmit('ruleForm')">登录</div>
            </el-form-item>
          </el-form>
        </div>
        <div v-if="type == 2">
          <el-form
            :model="ruleForm1"
            :rules="rules1"
            ref="ruleForm1"
            class="demo-ruleForm"
          >
            <el-form-item label="" prop="phone">
              <div class="item">
                <el-input
                  v-model="ruleForm1.phone"
                  placeholder="请输入手机号码"
                ></el-input></div
            ></el-form-item>
            <el-form-item label="" prop="code">
              <div class="item">
                <el-input
                  v-model="ruleForm1.code"
                  placeholder="请输入验证码"
                ></el-input>
                <div class="sendCode">发送验证码</div>
              </div></el-form-item
            >
            <el-form-item>
              <div
                class="btn"
                style="margin-bottom: 40px"
                @click="onSubmit('ruleForm1')"
              >
                登录
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="box" v-if="type == 1">
          <div>
            <!-- <el-checkbox v-model="checked">记住密码</el-checkbox> -->
          </div>
          <div>忘记密码？</div>
        </div>
        <!-- <div
          style="font-size: 12px;color: #1D2129;text-align: center;margin-top: 24px;"
        >
          <span>还没有账号？</span>
          <span style="color:#165DFF">免费注册</span>
        </div>
        <div style="margin-top: 50px;">
          <el-divider content-position="center">其他登录方式</el-divider>
        </div>
        <div class="wayBox">
          <div class="wayItem">
            <img src="../../assets/imgs/weixin.png" alt="" />
            <div>微信</div>
          </div>
          <div class="wayItem">
            <img src="../../assets/imgs/weibo.png" alt="" />
            <div>微博</div>
          </div>
          <div class="wayItem">
            <img src="../../assets/imgs/qq.png" alt="" />
            <div>QQ</div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
const Base64 = require("js-base64").Base64;
export default {
  data() {
    return {
      ruleForm: {
        name: "",
        pass: "",
        code: "",
      },
      ruleForm1: {
        phone: "",
        code: "",
      },
      checked: false,
      type: 1,
      rules: {
        name: [{ required: true, message: "请填写账号", trigger: "change" }],
        pass: [{ required: true, message: "请填写密码", trigger: "change" }],
      },
      rules1: {
        phone: [{ required: true, message: "请填写手机号", trigger: "change" }],
        code: [{ required: true, message: "请填写验证码", trigger: "change" }],
      },
      codeObj: {},
    };
  },
  mounted() {
    this.getImg();
  },
  created() {
    // 在页面加载时从cookie获取登录信息
    let username = this.getCookie("username");
    let password = this.getCookie("passWord");
    // 如果存在赋值给表单，并且将记住密码勾选
    if (username) {
      this.ruleForm.name = username;
      this.ruleForm.pass = password;
      this.checked = true;
    }
  },
  methods: {
    select(val) {
      this.type = val;
    },
    onSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return;
        }
        this.$axios
          .post(`/admapi/sys/users/login`, {
            account: this.ruleForm.name,
            password: this.ruleForm.pass,
            code: this.ruleForm.code,
            codekey: this.codeObj.uuid,
          })
          .then(({ data }) => {
            localStorage.setItem("TOKEN", data.token);
            localStorage.setItem("USERNAME", this.ruleForm.name);
            this.getList();
          })
          .catch()
          .finally();
      });
    },

    getImg() {
      this.$axios
        .post(`/admapi/sys/users/getCode`)
        .then(({ data }) => {
          this.codeObj = data;
        })
        .catch()
        .finally();
    },
    // 储存表单信息
    // setUserInfo: function() {
    //   // 判断用户是否勾选记住密码，如果勾选，向cookie中储存登录信息，
    //   // 如果没有勾选，储存的信息为空
    //   if (this.checked) {
    //     this.setCookie("username", this.ruleForm.name);
    //     this.setCookie("passWord", this.$md5(this.ruleForm.pass));
    //   } else {
    //     this.setCookie("username", "");
    //     this.setCookie("password", "");
    //   }
    // },
    // 获取cookie
    getCookie: function (key) {
      if (document.cookie.length > 0) {
        var start = document.cookie.indexOf(key + "=");
        if (start !== -1) {
          start = start + key.length + 1;
          var end = document.cookie.indexOf(";", start);
          if (end === -1) end = document.cookie.length;
          return unescape(document.cookie.substring(start, end));
        }
      }
      return "";
    },
    // 保存cookie
    setCookie: function (cName, value, expiredays) {
      var exdate = new Date();
      exdate.setDate(exdate.getDate() + expiredays);
      document.cookie =
        cName +
        "=" +
        decodeURIComponent(value) +
        (expiredays == null ? "" : ";expires=" + exdate.toGMTString());
    },
    //获取当前登录账号菜单
    getList() {
      this.$axios
        .post(`/admapi/sys/users/list-menus/current`)
        .then(({ data }) => {
          localStorage.setItem("rule", JSON.stringify(data));
          this.$router.push("/index");
          // this.setUserInfo();
          this.$router.go(0);
        })
        .catch()
        .finally();
    },
  },
};
</script>
<style scoped>
.sendCode {
  flex: none;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #165dff;
  line-height: 40px;
  margin-right: 20px;
  cursor: pointer;
}
.wayItem {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #4e5969;
  line-height: 17px;
}
.wayItem img {
  width: 25px;
  height: 25px;
  margin-bottom: 4px;
}
.wayBox {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.box {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 15px;
  color: #606266;
  font-size: 14px;
}
.btn {
  width: 100%;
  height: 40px;
  background: #165dff;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  margin-top: 8px;
  cursor: pointer;
}
.item {
  width: 100%;
  height: 40px;
  border-radius: 4px;
  /* border: 1px solid #e5e6eb; */
  display: flex;
  justify-content: space-between;
}
.solid {
  width: 2px;
  height: 16px;
  background: #c9cdd4;
}
.title_text {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  line-height: 22px;
  cursor: pointer;
}
.boxTitle {
  width: 100%;
  text-align: center;
  font-size: 24px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1d2129;
  line-height: 33px;
  letter-spacing: 2px;
}
.login-wrap {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
  position: relative;
}
.bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99;
}
.login {
  height: 440px;
  width: 490px;
  box-shadow: 0px 6px 42px 0px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  padding: 44px 100px;
  box-sizing: border-box;
  background: #fff;
  z-index: 999;
}
.loginImg {
  width: 416px;
  height: 541px;
  margin-right: 228px;
}
.loginImg img {
  width: 100%;
  height: 100%;
}
.sub-title {
  margin: 50px 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #1d2129;
  padding: 0 30px;
  box-sizing: border-box;
}
.subSelect {
  color: #165dff;
}
</style>
